import React from "react";
import { Box } from "@mui/material";
import NonIconButton from "../../../../components/NonIconButton";
import { NormalText } from "../../../../components/TextParts";

export default function RegistrationFailed({ handleClose, message }) {
  return (
    <Box sx={{ py: "20px" }}>
      <Box sx={{ my: "20px" }}>
        <NormalText text={message || "募集登録に失敗しました。"} />
      </Box>
      <NonIconButton title="閉じる" clickEvent={handleClose} />
    </Box>
  );
}